import { render, staticRenderFns } from "./VehicleStateForm.vue?vue&type=template&id=212f88f8"
import script from "./VehicleStateForm.vue?vue&type=script&lang=js"
export * from "./VehicleStateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports